import React, { useRef, useState, useEffect } from 'react';
import { Eraser } from 'lucide-react';
import { trimCanvas } from './SignaturePad';

export const DrawPad = ({ onChange }) => {
  const ref = useRef(null);
  const drawing = useRef(false);

  useEffect(() => {
    const ctx = ref.current.getContext('2d');
    ctx.lineWidth = 2.4; ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.strokeStyle = '#1c2f6e';
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [(e.clientX - r.left) * (ref.current.width / r.width), (e.clientY - r.top) * (ref.current.height / r.height)];
  };
  const start = (e) => { drawing.current = true; ref.current.setPointerCapture(e.pointerId); const ctx = ref.current.getContext('2d'); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext('2d'); ctx.lineTo(...pos(e)); ctx.stroke(); };
  const end = () => { if (!drawing.current) return; drawing.current = false; onChange(trimCanvas(ref.current)); };
  const clear = () => { const c = ref.current; c.getContext('2d').clearRect(0, 0, c.width, c.height); onChange(null); };

  return (
    <div>
      <canvas ref={ref} width={600} height={160} onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end}
        data-testid="agreement-signature-canvas" className="w-full h-32 bg-white border-2 border-dashed border-slate-400 rounded-lg touch-none cursor-crosshair" />
      <button type="button" onClick={clear} data-testid="agreement-signature-clear" className="mt-2 text-xs text-slate-500 hover:text-slate-800 flex items-center gap-1"><Eraser className="w-3 h-3" /> Clear</button>
    </div>
  );
};
